import { ApiError } from './ApiError';

export class ConcurrencyError extends ApiError {}
